import {useEffect} from 'react';
import {getFloorEcology} from '../data/floorEcology';
import {getFuchiFloor} from '../data/fuchiFloors';
import {getSpecimenFloor} from '../data/specimenCatalog';
import {
  getEnglishTier,
  translateSpecimen
} from '../data/specimenTranslations';

function localizeCabinet(root, floor) {
  const data = getFuchiFloor(floor);
  const ecology = getFloorEcology(data);
  const collection = getSpecimenFloor(floor);
  const buttons = root.querySelectorAll('.specimen-cabinet__item');

  buttons.forEach((button, index) => {
    const item = collection.items[index];
    if (!item) return;

    const creature = ecology.creatures[index % Math.max(1, ecology.creatures.length)];
    const translated = translateSpecimen(item, data, creature?.name_en);
    const name = button.querySelector('strong');
    const tier = button.querySelector('small');

    if (name) name.textContent = translated.name;
    if (tier) {
      tier.textContent = `${getEnglishTier(item.tier)} · ${
        item.tier >= 3 ? 'CLICK TO EXAMINE' : 'CONSTANT'
      }`;
    }

    button.dataset.englishName = translated.name;
    button.dataset.englishNote = translated.note;
  });

  const selected = root.querySelector('.specimen-cabinet__item.is-selected');
  const detail = root.querySelector('.specimen-cabinet__detail');

  if (selected && detail) {
    detail.textContent = `${selected.dataset.englishName} · ${
      selected.dataset.englishNote
    }`;
  }
}

export default function SpecimenLocalization({floor, lang}) {
  useEffect(() => {
    if (lang !== 'en') return undefined;

    const root = document
      .querySelector(`.floor-ecology[data-floor="${floor}"]`)
      ?.closest('.specimen-cabinet');

    if (!root) return undefined;

    const update = () => localizeCabinet(root, floor);
    const observer = new MutationObserver(update);

    update();
    observer.observe(root, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });

    root.addEventListener('click', update);
    return () => {
      observer.disconnect();
      root.removeEventListener('click', update);
    };
  }, [floor, lang]);

  return null;
}